<template>
	<article class="review-analysis-page">
		<form @submit.prevent="search">
			<managing-section :column-count="2">
				<managing-box title="브랜드">
					<search-brand-initial
						ref="SearchBrandInitial"
						@change="changeBrand"
					/>
				</managing-box>
				<managing-box title="제품">
					<select
						class="select review-analysis__product-selector"
						v-model="idProduct"
					>
						<option
							v-for="item in productList"
							:key="item.id"
							:value="item.id"
							:disabled="item.id === null"
						>
							{{ item.title }}
						</option>
					</select>
				</managing-box>
				<managing-box title="평점">
					<select class="select" v-model="rating">
						<option
							v-for="item in ratingList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</managing-box>
				<managing-box title="최소글자 수<br>(공백 포함)">
					<input-text
						@input="
							change([{ key: 'minReviewLength', value: $event }])
						"
						:propValue="minReviewLength"
						mode="number"
					/>
				</managing-box>
				<managing-box title="키워드">
					<input
						@input="
							change([
								{ key: 'keyword', value: $event.target.value },
							])
						"
						@keypress.enter.prevent="enterKeyword"
						:value="keyword"
						type="text"
						placeholder="입력 + Enter"
					/>
					<p class="review-analysis__keyword__desc">※ 클릭 시 삭제</p>
					<ul class="review-analysis__keyword-list">
						<li
							class="review-analysis__keyword-list__item"
							v-for="(item, idx) in keywordList"
							:key="`${item}${idx}`"
						>
							<button
								class="btn-delete"
								type="button"
								@click="deleteKeyword(idx)"
							>
								{{ item }}
							</button>
						</li>
					</ul>
				</managing-box>
				<managing-box title="평가단 여부">
					<select class="select" v-model="isEvaluation">
						<option
							v-for="item in isEvaluationList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</managing-box>
				<managing-box title="리뷰 등록 시간">
					<DateRange v-model="datePeriod" type="date" />
				</managing-box>
			</managing-section>
			<div class="btn-wrap-main">
				<button
					type="button"
					class="btn-main blue bordered"
					v-text="'조건 초기화'"
					@click="init"
				/>
				<button type="submit" class="btn-main blue" v-text="'검색'" />
			</div>
		</form>
		<managing-section :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					총 리뷰 수 : {{ reviewTotal }}건 / 평가단 리뷰 :
					{{ evaluationCnt }}건
				</div>
			</template>
			<table class="table-main review-analysis__review-table">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in parsedReviewList" :key="item.id">
						<td>{{ item.info }}</td>
						<td>{{ item.rating }}</td>
						<td>{{ item.date }}</td>
						<td class="review-analysis__review-table__review">
							{{ item.review }}
						</td>
						<td>
							<button
								class="btn review-analysis__review-table__analysis-btn"
								type="button"
								@click="
									openAnalysis(reviewList[idx], item.info)
								"
							>
								분석하기
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				:total-item="reviewTotal"
				:limit="50"
				:offset="offset"
				:page-leng-per-one="10"
				@to="paging"
				slot="pagination"
			/>
		</managing-section>
	</article>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrandInitial from '@/components/SearchBrandInitial.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import InputText from '@/components/InputText.vue';
	import DateRange from '@/components/DateRange';

	export default {
		name: 'ReviewAnalysis',
		components: {
			ManagingSection,
			ManagingBox,
			SearchBrandInitial,
			PaginationBox,
			InputText,
			DateRange,
		},
		data() {
			return {
				idProduct: null,
				productList: [],
				thList: ['회원정보', '평점', '날짜', '리뷰', '분석하기'],
				reviewList: [],
				evaluationCnt: 0,
				reviewTotal: 0,
				offset: 0,
				keyword: '',
				keywordList: [],
				keywordInput: null,
				minReviewLength: null,
				ratingList: [
					{ id: -1, name: '전체' },
					{ id: 1, name: '1' },
					{ id: 2, name: '2' },
					{ id: 3, name: '3' },
					{ id: 4, name: '4' },
					{ id: 5, name: '5' },
				],
				rating: -1,
				isEvaluationList: [
					{ id: -1, name: '전체' },
					{ id: 0, name: '일반' },
					{ id: 1, name: '평가단' },
				],
				isEvaluation: -1,
				datePeriod: { from: '', to: '' },
				brandId: null,
				brandTitle: '',
				mountedTime: false,
			};
		},
		computed: {
			parsedReviewList() {
				return this.reviewList.map(item => ({
					id: item.idreviewcomment,
					info: `${item.nickname} (${item.gender}, ${item.skinType})`,
					rating: item.rating,
					date: item.create_date,
					review: item.reviewText.join(' '),
				}));
			},
		},
		watch: {
			'$route.query'(query) {
				this.setFilter(query);
				if (typeof this.idProduct === 'number') this.getProductList();
			},
		},
		mounted() {
			this.mountedTime = true;
			this.setFilter(this.$route.query);
		},
		methods: {
			change(changeList) {
				changeList.forEach(({ key, value }) => {
					if (this.hasOwnProperty(key)) {
						this[key] = value;
					}
				});
			},
			enterKeyword: _.debounce(function () {
				if (!this.keyword) {
					this.push();
					return;
				}
				if (this.keywordList.some(item => item === this.keyword)) {
					alert('중복 키워드가 있습니다.');
					return;
				}
				this.keywordList.push(this.keyword);
				this.keyword = '';
			}, 100),
			async changeBrand(obj) {
				try {
					if (obj.id === null) return;
					if (
						this.mountedTime &&
						this.$route.query.brandId &&
						this.$route.query.idProduct
					) {
						this.idProduct = Number(this.$route.query.idProduct);
						this.getProductList();
					} else {
						this.idProduct = null;
					}
					this.mountedTime = false;
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/brand/${obj.id}/products`
					);
					this.productList = data.products.reduce(
						(acc, item) => {
							acc.push({
								title: `[${item.idProduct}] ${item.productTitle}`,
								id: item.idProduct,
							});
							return acc;
						},
						[{ id: null, title: `제품 (${data.total})` }]
					);
					this.brandId = obj.id;
					this.brandTitle = obj.title;
				} catch (err) {
					console.error(err);
					alert(
						'상품목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async getReviewList() {
				try {
					const params = {
						idProduct: this.idProduct,
						offset: this.offset,
						limit: 50,
					};
					if (this.rating !== -1) params.rating = this.rating;
					if (this.isEvaluation !== -1)
						params.isEvaluation = this.isEvaluation;
					if (this.minReviewLength !== null)
						params.minReviewLength = this.minReviewLength;
					if (this.keywordList.length > 0)
						params.keywords = this.keywordList.join(',');
					if (this.datePeriod.from)
						params.startDate = this.datePeriod.from.replaceAll(
							'-',
							''
						);
					if (this.datePeriod.to)
						params.endDate = this.datePeriod.to.replaceAll('-', '');
					const { data } = await this.$axiosAdmin2.get(
						'/api/analysis/reviews/product',
						{ params }
					);
					this.reviewList = data.reviews;
				} catch (err) {
					console.error(err);
					alert(
						'리뷰목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async getProductList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/product/${this.idProduct}/total`
					);
					this.evaluationCnt = data.evaluationCnt;
					this.reviewTotal = data.total;
					await this.getReviewList();
				} catch (err) {
					console.error(err);
					alert(
						'상품목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			paging({ offset }) {
				this.offset = offset;
				this.push();
			},
			openAnalysis(data, info) {
				this.$store.commit('modal/toggleModal', {
					id: 'ReviewAnalysis',
					modalTitle: info,
					params: {
						data,
						keywordList: this.keywordList,
						parent: this,
					},
				});
			},
			deleteKeyword(idx) {
				this.keywordList.splice(idx, 1);
			},
			push() {
				const query = {};
				if (this.brandId !== null) {
					query.brandId = this.brandId;
					query.brandTitle = this.brandTitle;
				}
				if (this.idProduct !== null) {
					query.idProduct = this.idProduct;
					query.productTitle = this.productList.filter(
						item => item.id === this.idProduct
					)[0].title;
				}
				if (this.rating !== -1) {
					query.rating = this.rating;
				}
				if (this.minReviewLength !== null) {
					query.minReviewLength = this.minReviewLength;
				}
				if (this.keywordList.length) {
					query.keywordList = JSON.stringify(this.keywordList);
				}
				if (this.isEvaluation !== -1) {
					query.isEvaluation = this.isEvaluation;
				}
				if (this.datePeriod.from) {
					query.startDate = this.datePeriod.from;
				}
				if (this.datePeriod.to) {
					query.endDate = this.datePeriod.to;
				}
				if (this.offset !== 0) {
					query.offset = this.offset;
				}
				this.$router.push({ query }).catch(err => {
					window.location.reload();
				});
			},
			search() {
				if (this.idProduct === null) {
					alert('선택된 상품이 없습니댜.');
					return;
				}
				this.offset = 0;
				this.push();
			},
			setFilter(query) {
				this.offset = query.offset ? Number(query.offset) : 0;
				if (query.brandId) {
					this.$refs.SearchBrandInitial.idInitial = null;
					this.$refs.SearchBrandInitial.brandList = [
						{ id: Number(query.brandId), title: query.brandTitle },
					];
					this.$refs.SearchBrandInitial.selectedBrandId = Number(
						query.brandId
					);
				} else {
					this.$refs.SearchBrandInitial.idInitial = 0;
					this.idProduct = null;
					this.productList = [];
					this.$refs.SearchBrandInitial.getBrandList();
				}
				this.rating = query.rating ? Number(query.rating) : -1;
				this.minReviewLength = query.minReviewLength
					? query.minReviewLength
					: null;
				this.keywordList = query.keywordList
					? JSON.parse(query.keywordList)
					: [];
				this.isEvaluation = query.isEvaluation
					? Number(query.isEvaluation)
					: -1;
				this.datePeriod = {
					from: query.startDate || '',
					to: query.endDate || '',
				};
			},
			init() {
				this.evaluationCnt = 0;
				this.reviewTotal = 0;
				this.reviewList = [];
				this.$router.push({ query: {} }).catch(() => {
					window.location.reload();
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.review-analysis__product-selector {
		width: 100%;
	}

	.review-analysis__keyword__desc {
		display: block;
		margin: 8px 0 4px;
		line-height: 18px;
		color: $red;
		font-size: 0.875rem;
		font-weight: normal;
	}

	.review-analysis__keyword-list {
		font-size: 0;
	}

	.review-analysis__keyword-list__item {
		display: inline-block;
		font-size: 0.875rem;
		margin-top: 4px;
		margin-right: 8px;

		&:last-child {
			margin-right: 0;
		}
	}

	.review-analysis__review-table {
		th,
		td {
			white-space: nowrap;
		}

		.review-analysis__review-table__review {
			line-height: 18px;
			text-align: left;
			white-space: normal;
		}
	}

	.review-analysis__review-table__analysis-btn {
		margin-left: auto;
		margin-right: auto;
	}
</style>
